import Constant from '@/common/constant/Constant';
import { BASIC_SETTING, ADVANCED_SETTING } from '@/common/constant/ModuleSettingVersionConstant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import Utils from '@/common/utils/utils';
import { getDetailByProductId, getProductById, updateProductManagement } from '@/service/productManagementService';
import _ from 'lodash';
import { getPublicAPI } from '@/service/publicService';
import { resolveKBoardPromptTicket } from '@/component/common/handler/KBoardSystemPromptHandler';

import { v4 as uuidv4 } from 'uuid';
import MessageCode from '@/common/constant/MessageCode';
import { checkModelUnsupport } from '@/component/system/handler/OrganizationProfileHandler';
import I18n from '@/rI18n';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

export const invalidCharsLimitValue = ['.', '-', '+', 'e', 'E', ',', '/'];
export const specialCharacters = ['!','@','#','$','%','^','&','*','(',')','_','-','+','[',']','{','}',':',';','"',"'",'|','\\','/','<','>','?',',','.'
];

export const filterLabelByKey = key => {
    const constants = {
        internalQACounterSettings: '問い合わせ窓口設置',
        externalServiceDeskSettings: '組織外向けサービスデスク機能',
        deskService: '公開サービスデスクプロジェクト設置',
        publicWebForm: '公開Webフォーム',
        emailResponseFunction: 'メール対応機能',
        knowledgeFunction: 'ナレッジ機能',
        knowledgeService: 'SolutionDeskでのナレッジ利用',
        publicService: '公開ナレッジ',
        knowledgeBot: 'ナレッジロボ',
        synonymSearch: '類義語検索',
        convertPDF: 'PDF検索',
        batchCommandService: '一括コマンド',
        chatAI: 'AI',
        lincenseKeyPermission: '貸出ライセンスキー利用を許可する',
        aiAuto: 'AIオート',
        sdAuto: 'SDオート',
        telephoneAgent: 'ボイスエージェント機能',
        fileTranslation: 'ファイル翻訳',
        kBoard: 'K-Board',
        externalWebAPI: '外部WebAPI',
        mcpServer: '外部連携',
        multiLanguage: '多言語対応',

        taskManagement: '課題管理機能',
        advancedOptionSettings: '拡張オプション',
        logAnalysis: '分析',
        ipRestriction: 'IPアドレス制限',

        numberOfTickets: 'チケット数',
        numberOfKnowledges: 'ナレッジ数',
        numberOfFormat: 'フォーマット数',
        numberOfQACounters: '問い合わせ窓口数',
        numberOfSupportedCounters: 'サポート窓口数',
        numberOfGeneralProjects: 'プロジェクト数',
        numberOfInternalCustomers: '組織内カスタマーID数',
        numberOfB2C: '個人カスタマーID数',
        storageVolume: 'ストレージ容量',
        generalUserFee: '一般ユーザーID料金',
        basicCharge: '基本料金',
        numberOfExWebAPI: '外部Web呼び出し回',

        numberOfAdditionalTickets: 'チケット数追加',
        numberOfAdditionalKnowledge: 'ナレッジ数追加',
        numberOfAdditionalStorages: 'ストレージ追加',
        numberOfAdditionalQACounter: '問い合わせ窓口数追加',
        numberOfAdditionalSupportedCounter: 'サポート窓口数追加',
        numberOfAdditionalExWebAPI: ' 外部Web呼び出し回追加',

        multiAuth: '多要素認証'
    };

    const foundEntry = Object.entries(constants).find(([k, v]) => k === key);

    if (foundEntry) {
        return foundEntry[1];
    } else {
        return '';
    }
};

export const filterUnitByKey = key => {
    const constants = {
        quantity: '個',
        storage: 'Gb',
        price: '円',
        setPersion: '個/人',
        setCorp: '個/組織',
        setCorpPersion: '人/組織',
        gbPersion: 'Gb/人',
        numberCallPerMonth: '回/月/組織',
    };

    const foundEntry = Object.entries(constants).find(([k, v]) => k === key);

    if (foundEntry) {
        return foundEntry[1];
    } else {
        return '';
    }
};

export const renderUnitAdvancedByKeyAndType = ( key, type ) => {
    if (key === 'quantity' && type === 'number') return '個';
    if (key === 'quantity' && type === 'decimal') return 'Gb';
    if (key === 'price' && type === 'number') return '円';
    return '';
};

export const handleValidateAdvancedSettingOption = (
    edittingKey,
    edittingKeyOfValue,
    otherKey,
    otherKeyOfValue,
    field,
    setValue,
    errorEditingKey,
    errorOtherKey
) => {
    let errors = {
        [edittingKey]: errorEditingKey,
        [otherKey]: errorOtherKey
    };

    if (edittingKeyOfValue.length === 0) {
        if (otherKeyOfValue.length > 0) {
            errors[edittingKey] = I18n.get('COMMSG014');
        } else {
            errors[otherKey] = '';
        }
    } else if (otherKeyOfValue.length === 0) {
        errors[otherKey] = I18n.get('COMMSG014');
    }

    setValue(prev => ({
        ...prev,
        [field]: {
            ...prev[field],
            [edittingKey]: {
                ...prev[field][edittingKey],
                error: errors[edittingKey]
            },
            [otherKey]: {
                ...prev[field][otherKey],
                error: errors[otherKey]
            }
        }
    }));
};

export const checkValueOfVersionName = versionName => {
    if (Utils.isEmptyString(versionName.value) || !Utils.isEmptyString(versionName.error)) {
        return false;
    }
    return true;
};

export const checkValueOfKnn = knn => {
    if (Utils.isEmptyString(knn.value) || !Utils.isEmptyString(knn.error)) {
        return false;
    }
    return true;
};
export const checkValueOfMinScore = minScore => {
    if (Utils.isEmptyString(minScore.value) || !Utils.isEmptyString(minScore.error)) {
        return false;
    }
    return true;
};

export const checkValueOfChatGPTModel = chatGPT => {
    if (Utils.isEmptyString(chatGPT)) {
        return false;
    }
    return true;
};

const filterActiveBasicSetting = (conditions, obj) => {
    let isInternalQACounter = conditions.internalQACounterSettings.value;
    let isKnowledgeFunction = conditions.knowledgeFunction.group.knowledgeService.value;
    let isExternalServiceDesk =
        conditions.externalServiceDeskSettings.group.deskService.value;
    let isUnlimitedExWevAPI = obj.numberOfExWebAPI.isUseUnlimited.value;

    let activeObj = {}
    const keysToFilter = [
        'numberOfQACounters',
        'numberOfKnowledges',
        'numberOfSupportedCounters',
        'numberOfB2C'
    ];
    for (const key in obj) {
        if (!keysToFilter.includes(key)) {
            activeObj[key] = obj[key];
        }
    }
    if (!isInternalQACounter) {
        delete activeObj.numberOfQACounters;
    } else {
        activeObj.numberOfQACounters = {
            ...BASIC_SETTING.numberOfQACounters,
            value: obj.numberOfQACounters.value,
            error: obj.numberOfQACounters.error,
        };
    }

    if (!isKnowledgeFunction) {
        delete activeObj.numberOfKnowledges;
    } else {
        activeObj.numberOfKnowledges = {
            ...BASIC_SETTING.numberOfKnowledges,
            value: obj.numberOfKnowledges.value,
            error: obj.numberOfKnowledges.error,
        };
    }

    if (!isExternalServiceDesk) {
        delete activeObj.numberOfSupportedCounters;
        delete activeObj.numberOfB2C;
    } else {
        activeObj.numberOfSupportedCounters = {
            ...BASIC_SETTING.numberOfSupportedCounters,
            value: obj.numberOfSupportedCounters.value,
            error: obj.numberOfSupportedCounters.error,
        };
        activeObj.numberOfB2C = {
            ...BASIC_SETTING.numberOfB2C,
            value: obj.numberOfB2C.value,
            error: obj.numberOfB2C.error,
        };
    }

    if (isUnlimitedExWevAPI) {
        delete activeObj.numberOfExWebAPI;
    } else {
        activeObj.numberOfExWebAPI = {
            ...BASIC_SETTING.numberOfExWebAPI.number,
            value: obj.numberOfExWebAPI.number.value,
            error: obj.numberOfExWebAPI.number.error,
        };
    }

    return activeObj;
}

export const checkValueOfBasicSetting = (conditions, obj) => {
    const activeBasicSettingObj = filterActiveBasicSetting(conditions, obj);

    let isValid = Object.values(activeBasicSettingObj).every(option => {
        if (Utils.isEmptyString(option.value)) return false;
        if (!Utils.isEmptyString(option.error)) return false;
        return true;
    });

    Object.entries(obj).forEach((item) => {
        if (!Utils.isEmptyString(item[1]?.error)) {
            return isValid = false;
        }
    })

    return isValid;
};

export const checkValueOfAdvancedSetting = (advancedSetting) => {
    let isValid = true;

    Object.entries(advancedSetting).forEach((item) => {
        const quantityValue = item[1]?.quantity?.value?.trim();
        const priceValue = item[1]?.price?.value?.trim();

        if (
            !Utils.isEmptyString(item[1]?.price?.error) ||
            !Utils.isEmptyString(item[1]?.quantity?.error)
        ) {
            return (isValid = false);
        }

        if (quantityValue?.length > 0) {
            if (priceValue?.length === 0) {
                isValid = false;
                return; // Exit the loop immediately
            }
        } else {
            if (priceValue?.length > 0) {
                isValid = false;
                return; // Exit the loop immediately
            }
        }
    });

    return isValid;
};

const checkValueOfLincenseKey = (lincenseKey, functionSettingValue) => {
    let isValid = true;
    if(functionSettingValue.lincenseKeyPermission.value) {
        if(Utils.isEmptyString(lincenseKey.value) || !Utils.isEmptyString(lincenseKey.error)) return false;
    }
    return isValid;
}

export const handleRequiedField = (
    versionName,
    setVersionName,
    functionSettingValue,
    setFunctionSettingValue,
    basicSettingValue,
    setBasicSettingValue,
    advancedSettingValue,
    setAdvancedSettingValue,
    lincenseKey,
    setLincenseKey,
    basicPromptAI,
    defaultBasicAIPrompt
) => {
    const requiredMessage = I18n.get('COMMSG014');

    const checkSubmitdata = handleCheckSubmitData(
        versionName,
        functionSettingValue,
        basicSettingValue,
        advancedSettingValue,
        null,
        null, 
        null, 
        null, 
        null,
        null,
        lincenseKey,
        basicPromptAI,
        defaultBasicAIPrompt
    );
    if(!checkSubmitdata) {
        if(Utils.isEmptyString(versionName.value)) {
            setVersionName(prev => ({
                ...prev,
                error: I18n.get('COMMSG014')
            }))
        }
        if(functionSettingValue.knowledgeFunction.group.lincenseKeyPermission.value) {
            if(Utils.isEmptyString(lincenseKey.value)) {
                setLincenseKey(prev => ({
                    ...prev,
                    error: requiredMessage
                }))
            }
        }
        const getActiveBasicSetting = filterActiveBasicSetting(
            functionSettingValue,
            basicSettingValue
        );
        Object.entries(getActiveBasicSetting).forEach((option) => {
            if (Utils.isEmptyString(option[1].value)) {
                setBasicSettingValue(prev => ({
                    ...prev,
                    [option[0]]: {
                        ...prev[option[0]],
                        error: requiredMessage
                    }
                }))
            }
        });
        Object.entries(advancedSettingValue).forEach((item) => {
            handleValidateAdvancedSettingOption(
                'quantity',
                item[1].quantity.value,
                'price',
                item[1].price.value,
                item[0],
                setAdvancedSettingValue,
                item[1].quantity?.error,
                item[1].price?.error
            )
        });
    }
};

export const handleCheckSubmitData = (
    versionName,
    functionSettingValue,
    basicSettingValue,
    advancedSettingValue,
    isEditVersion,
    defaultFunctionSettingValue, 
    defaultBasicSettingValue, 
    defaultAdvancedSettingValue, 
    defaultVersionNameValue,
    setIsEdit,
    lincenseKey,
    isChangeLincenseKey,
    basicAIPrompt,
    defaultBasicAIPrompt,
    knn,
    minScore,
    chatGPTModel,
    knnDefault,
    minScoreDefault,
    chatGPTModelDefault,
    modelSettingList, 
    modelSettingAddList,
    modelSettingListRoot,
    chatGPTModelList,
    kBoardSystemPromptLink,
    defaultKBoardSystemPromptLink
) => {
    let isValidVersionName = checkValueOfVersionName(versionName);
    let isValidBasicSettingValue = checkValueOfBasicSetting(
        functionSettingValue,
        basicSettingValue
    );
    let isValidAdvancedSettingValue = checkValueOfAdvancedSetting(
        advancedSettingValue
    );
    let isValidLincenseKey = checkValueOfLincenseKey(lincenseKey, functionSettingValue);

    let isValidKnn = checkValueOfKnn(knn);
    let isValidMinScore = checkValueOfMinScore(minScore);
    let isValidChatGPTModel = checkValueOfChatGPTModel(chatGPTModel);
    let isModelGptUnsupport = checkModelUnsupport(chatGPTModel, chatGPTModelList);
    let isExistPromptValid = isExistPromptError(modelSettingList, modelSettingAddList);
    let isExistModelError = validateModelError(modelSettingList, modelSettingAddList, chatGPTModelList);

    let result = true;
    if (
        !isValidVersionName ||
        !isValidBasicSettingValue ||
        !isValidAdvancedSettingValue ||
        !isValidLincenseKey ||
        !isValidKnn ||
        !isValidMinScore ||
        !isValidChatGPTModel ||
        isExistPromptValid ||
        isExistModelError ||
        isModelGptUnsupport
    ) {
        result = false;
    }

    if (isEditVersion && result) {
        let isEditVersionName = _.isEqual(defaultVersionNameValue, versionName);
        let isEditFunctionSettingValue = _.isEqual(defaultFunctionSettingValue, functionSettingValue);
        let isEditBasicSettingValue = _.isEqual(defaultBasicSettingValue, basicSettingValue);
        let isEditModelSettingValue = _.isEqual(modelSettingList, modelSettingListRoot) && modelSettingAddList.length === 0;
        let isEditAdvancedSettingValue = _.isEqual(defaultAdvancedSettingValue, advancedSettingValue);
        let isEditBasicPromptAi = basicAIPrompt?.id !== defaultBasicAIPrompt?.id
        let isEditKnn = _.isEqual(knnDefault, knn);
        let isEditMinScore = _.isEqual(minScoreDefault, minScore);
        let isEditChatGPTModel = _.isEqual(chatGPTModelDefault, chatGPTModel);
        let isEditKBoardSystemPrompt = (kBoardSystemPromptLink || '') === (defaultKBoardSystemPromptLink || '');
        
        if (
            isEditVersionName &&
            isEditFunctionSettingValue &&
            isEditBasicSettingValue &&
            isEditAdvancedSettingValue &&
            !isChangeLincenseKey &&
            !isEditBasicPromptAi &&
            isEditKnn &&
            isEditMinScore &&
            isEditChatGPTModel &&
            isEditModelSettingValue &&
            isEditKBoardSystemPrompt
        ) {
            result = false;
            if (setIsEdit) {
                setIsEdit(false);
            }
        }
    }

    return result;
};

export const isExistPromptError = (modelSettingList, modelSettingAddList) => {
    let listValidate = [...modelSettingAddList, ...modelSettingList];
    let isEsistPromptErr = listValidate.some(item => {
        return item.systemPrompt?.error?.trim() !== '' 
        // || item.interatorSystemPrompt?.error?.trim() !== '';
    });
    return isEsistPromptErr;
}

export const validateModelError = (list1, list2, chatGPTModelList = []) => {
    const listValidate = [...list1, ...list2];
    return listValidate.some(item => {
        const modelStatus = chatGPTModelList?.find(m => m.id?.toLowerCase() === item.model?.toLowerCase())?.status;
        return modelStatus === Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT || !Utils.isEmptyString(item?.error);
    });
};

export const handleSubmitFormVersion = async (dataSubmit) => {
    let {
        API,
        isSubmit,
        versionName,
        setVersionName,
        functionSettingValue,
        setFunctionSettingValue,
        basicSettingValue,
        setBasicSettingValue,
        advancedSettingValue,
        setAdvancedSettingValue,
        setUsedFormButtonExpand,
        dataProduct,
        userId,
        setIsLoading,
        enqueueSnackbar,
        onBackEditionPanel,
        setOpenDropDownVersion,
        isEditVersion,
        setIsOpenModalReloadPage,
        setIsBackToProduct,
        setIsBackToEdition,
        isDuplicateVersion,
        lincenseKey,
        setLincenseKey,
        affiliationOrganization,
        basicPromptAI,
        defaultBasicAIPrompt,

        systemPrompt,
        chatGPTModel,
        knn,
        minScore,
        setDefaultSystemPrompt,
        setChatGPTModelDefault,
        setKnnDefault,
        setMinScoreDefault,
        interatorSystemPrompt,
        setDefaultInteratorSystemPrompt,
        setModelSettingList,
        setModelSettingAddList,
        modelSettingList,
        modelSettingAddList,
        isShowPopUpCancel, 
        setIsShowPopUpCancel,
        setIsReloadPage,
        listGptModel,
        kBoardSystemPrompt
    } = dataSubmit;
    if(!isSubmit) {
        //TODO: check field required
        handleRequiedField(
            versionName,
            setVersionName,
            functionSettingValue,
            setFunctionSettingValue,
            basicSettingValue,
            setBasicSettingValue,
            advancedSettingValue,
            setAdvancedSettingValue,
            lincenseKey,
            setLincenseKey,
            basicPromptAI,
            defaultBasicAIPrompt
        );
        setUsedFormButtonExpand(true)
        return;
    }
    let isExistPromptValid = isExistPromptError(modelSettingList, modelSettingAddList);
    let isExistModelError = validateModelError(modelSettingList, modelSettingAddList, listGptModel);
    if (isExistPromptValid || isExistModelError) {
        if (isShowPopUpCancel) setIsShowPopUpCancel(false);
        return;
    }

    setIsLoading(true);
    // Validate Duplicate/Required
    let dataValid = updateDuplicateError(modelSettingList, modelSettingAddList);
    if (dataValid?.hasAnyDuplicate || dataValid?.hasAnyBlankModel) {
        setModelSettingList(dataValid.newListModelSetting);
        setModelSettingAddList(dataValid.newListAddModelSetting);
        setIsLoading(false);
        return;
    }

    let addModelSetting = modelSettingAddList.map(item => {
        let newData = {
            interatorSystemPrompt: item.interatorSystemPrompt.linkPrompt,
            model: item.model,
            systemPrompt: item.systemPrompt.linkPrompt,
        }
        return newData;
    })
    let updateModelSetting = modelSettingList.map(item => {
        let newData = {
            interatorSystemPrompt: item.interatorSystemPrompt.linkPrompt,
            model: item.model,
            systemPrompt: item.systemPrompt.linkPrompt,
            createdAt: item.createdAt
        }
        return newData;
    })

    const moduleSetting = {
        internalQACounterSettings: functionSettingValue.internalQACounterSettings.value,
        deskService:
            functionSettingValue.externalServiceDeskSettings.group.deskService.value,
        publicWebForm: functionSettingValue.externalServiceDeskSettings.group.publicWebForm.value,
        emailResponseFunction: functionSettingValue.emailResponseFunction.value,
        knowledgeService:
            functionSettingValue.knowledgeFunction.group.knowledgeService.value,
        publicService: functionSettingValue.knowledgeFunction.group.publicService.value,
        knowledgeBot: functionSettingValue.knowledgeFunction.group.knowledgeBot.value,
        synonymSearch: functionSettingValue.knowledgeFunction.group.synonymSearch.value,
        convertPDF: functionSettingValue.knowledgeFunction.group.convertPDF.value,
        batchCommandService: functionSettingValue.knowledgeFunction.group.batchCommandService.value,
        chatAI: functionSettingValue.chatAI.value,
        lincenseKeyPermission: functionSettingValue.chatAI.value ? functionSettingValue.lincenseKeyPermission.value : false,
        chatGPTModel: chatGPTModel,
        knnValue: knn.value,
        minScore: minScore.value,
        aiAuto: functionSettingValue.chatAI.value ? functionSettingValue.aiAuto.value : false,
        sdAuto: functionSettingValue.chatAI.value ? functionSettingValue.sdAuto.value : false,
        telephoneAgent: functionSettingValue.chatAI.value && functionSettingValue?.aiAuto?.value && functionSettingValue?.telephoneAgent?.value ? true : false,
        fileTranslation: functionSettingValue.chatAI.value && functionSettingValue?.aiAuto?.value && functionSettingValue?.fileTranslation?.value ? true : false,
        kBoard: functionSettingValue.chatAI.value && functionSettingValue?.kBoard?.value ? true : false,
        kBoardSystemPrompt: kBoardSystemPrompt || '',
        systemPrompt: '',
        interatorSystemPrompt: '',
        externalWebAPI: functionSettingValue?.externalWebAPI?.value || false,
        mcpServer: functionSettingValue?.mcpServer?.value || false,
        localMcpEnabled: JSON.stringify(functionSettingValue?.localMcpEnabled?.value || {}),
        multiLanguage: functionSettingValue?.multiLanguage?.value || false,
        taskManagement: functionSettingValue.taskManagement.value,
        advancedOptionSettings: functionSettingValue.advancedOptionSettings.value,
        logAnalysis: functionSettingValue.logAnalysis.value,
        ipRestriction: functionSettingValue.ipRestriction.value,
        multiAuth: functionSettingValue.multiAuth.value,

        numberOfTickets: Utils.removeExcessZeros(basicSettingValue.numberOfTickets.value),
        numberOfKnowledges: Utils.removeExcessZeros(basicSettingValue.numberOfKnowledges.value),
        numberOfFormat: Utils.removeExcessZeros(basicSettingValue.numberOfFormat.value),
        numberOfQACounters: Utils.removeExcessZeros(basicSettingValue.numberOfQACounters.value),
        numberOfSupportedCounters: Utils.removeExcessZeros(basicSettingValue.numberOfSupportedCounters.value),
        numberOfGeneralProjects: Utils.removeExcessZeros(basicSettingValue.numberOfGeneralProjects.value),
        numberOfInternalCustomers: Utils.removeExcessZeros(basicSettingValue.numberOfInternalCustomers.value),
        numberOfB2C: Utils.removeExcessZeros(basicSettingValue.numberOfB2C.value),
        storageVolume: Utils.removeExcessZeros(basicSettingValue.storageVolume.value),
        generalUserFee: Utils.removeExcessZeros(basicSettingValue.generalUserFee.value),
        basicCharge: Utils.removeExcessZeros(basicSettingValue.basicCharge.value),
        numberOfExWebAPI: {
            number: Utils.removeExcessZeros(basicSettingValue?.numberOfExWebAPI?.number?.value),
            isUseUnlimited: basicSettingValue?.numberOfExWebAPI?.isUseUnlimited?.value
        },

        numberOfAdditionalTickets: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalTickets.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalTickets.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalKnowledge: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalKnowledge.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalKnowledge.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalStorages: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalStorages.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalStorages.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalQACounter: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalQACounter.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalQACounter.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalSupportedCounter: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalSupportedCounter.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalSupportedCounter.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalExWebAPI: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalExWebAPI.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalExWebAPI.price.value),
            unitPrice: 'JPY'
        },

        addModelSetting: JSON.stringify(addModelSetting || []),
        updateModelSetting: JSON.stringify(updateModelSetting || []),
    };
    let type = ProductManagementConstant.CREATE_VERSION;
    let versionId = '';
    if (isEditVersion) {
        type = ProductManagementConstant.METHOD_PRODUCT.UPDATE_VERSION;
        versionId = dataProduct.versionId;
    }
    if (isDuplicateVersion) {
        type = ProductManagementConstant.METHOD_PRODUCT.COPY_VERSION;
        versionId = dataProduct.versionId;
    }
    let lincenseKeySetting = {
        key: lincenseKey.value,
        affiliationOrganization: affiliationOrganization
    };

    if (!functionSettingValue.chatAI.value) {
        lincenseKeySetting.key = '';
    }

    if (lincenseKey.value == Constant.NOT_ROOT_SETTING_KEY) {
        lincenseKeySetting = null;
    }
    let requestBody = {
        type: type,
        productId: dataProduct?.productId,
        editionId: dataProduct?.editionId,
        versionName: versionName.value,
        moduleSetting: moduleSetting,
        userId: userId,
        versionId: versionId,
        lincenseKeySetting: lincenseKeySetting ? JSON.stringify(lincenseKeySetting) : null,
        basicPromptAI: Utils.isEmptyString(basicPromptAI?.id) ? 'none' : basicPromptAI.id
    };

    let res = await updateProductManagement(API, requestBody);

    if (!res || !res?.status) {
        // todo show error message
        setIsLoading(false);
        let moduleSettingUpdate = Utils.convertJSONDataToObject(res?.moduleSetting);
        if (moduleSettingUpdate?.isError) {
            setModelSettingList(moduleSettingUpdate.listModelSetting);
            setModelSettingAddList(moduleSettingUpdate.listAddModelSetting);
        }

        switch (res?.errorMessage) {
            case "MSG-CM-DATA-DUPLICATION":
                setVersionName(prevState => ({
                    ...prevState,
                    error: I18n.get('MSG-CM-VERSION-DATA-DUPLICATION')
                }));
                return;
            case "isNotProductExist":
                setIsBackToProduct(true)
                setIsOpenModalReloadPage(true);
                return;
            case "isNotEditionExist":
            case "isNotVersionExist":
                setIsBackToEdition(true)
                setIsOpenModalReloadPage(true);
                return;
            case 'MSG_AI_LICENSE_KEY_INVALID':
                setLincenseKey(prev => ({
                    ...prev,
                    error: I18n.get('MSG-AI-LICENSE-KEY-INVALID')
                }));
                return;
            case 'MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN':
            case 'MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN-INTERATOR':
                return;
            case MessageCode.DATA_CHANGED_PLEASE_RELOAD:
                setIsReloadPage(true);
                return;
            default:
                enqueueSnackbar(buildSnackbarMessage('SYSMSG001'), {
                    variant: 'error',
                    autoHideDuration: 3000
                });
                return;
        }
    }
    setDefaultSystemPrompt(systemPrompt);
    setDefaultInteratorSystemPrompt(interatorSystemPrompt);
    setChatGPTModelDefault(chatGPTModel)
    setKnnDefault(knn);
    setMinScoreDefault(minScore);
    setIsLoading(false);
    if (isEditVersion) {
        enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS', { '{{data_type}}': 'バージョン' }), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } else {
        enqueueSnackbar(buildSnackbarMessage('MSG-CM-SAVE-DATA-SUCCESS'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    }

    let editionData = {
        id: dataProduct?.productId,
        productId: dataProduct?.productId,
        name: dataProduct?.nameProduct
    }

    setOpenDropDownVersion(prevState => {
        let index = Utils.findIndexInArrayById(dataProduct.editionId, prevState);
        if(index !== -1) {
            prevState[index].open = true;
        }
        return prevState;
    })

    onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST)
};

export const callBackReloadPage = (onBackEditionPanel, isBackToProduct, isBackToEdition, dataProduct, setOpenDropDownVersion) => {
    if (isBackToProduct) {
        onBackEditionPanel(
            {},
            ProductManagementConstant.PRODUCT_LIST
        );
    }

    if (isBackToEdition) {
        let editionData = {
            id: dataProduct?.productId,
            productId: dataProduct?.productId,
            name: dataProduct?.nameProduct
        }
    
        setOpenDropDownVersion(prevState => {
            let index = Utils.findIndexInArrayById(dataProduct.editionId, prevState);
            if(index !== -1) {
                prevState[index].open = true;
            }
            return prevState;
        })
    
        onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST);
    }
}

export const onClickNoCanCelOrClosePanel = (
    dataProduct,
    onBackEditionPanel,
    setIsClosePanelVersion
) => {
    let editionData = {
        id: dataProduct?.productId,
        productId: dataProduct?.productId,
        name: dataProduct?.nameProduct
    };
    onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST);
    setIsClosePanelVersion({
        isClose: false,
        componentType: ProductManagementConstant.EDITION_LIST
    });
};

export const onYesCanCelOrClosePanel = async (
    API,
    setIsClosePanelVersion,
    isSubmit,
    functionSettingValue,
    setFunctionSettingValue,
    basicSettingValue,
    setBasicSettingValue,
    advancedSettingValue,
    setAdvancedSettingValue,
    setUsedFormButtonExpand,
    dataProduct,
    versionName,
    userId,
    setIsLoading,
    enqueueSnackbar,
    onBackEditionPanel,
    setIsShowPopUpCancel,
    setOpenDropDownVersion,
    setVersionName,
    isEditVersion,
    setIsOpenModalReloadPage,
    setIsBackToProduct,
    setIsBackToEdition,
    isDuplicateVersion,
    lincenseKey,
    setLincenseKey,
    basicAIPrompt,
    defaultBasicAIPrompt,
    affiliationOrganization,

    systemPrompt,
    chatGPTModel,
    knn,
    minScore,
    setDefaultSystemPrompt,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    interatorSystemPrompt,
    setDefaultInteratorSystemPrompt,
    setModelSettingList,
    setModelSettingAddList,
    modelSettingList,
    modelSettingAddList,
    isShowPopUpCancel,
    setIsReloadPage,
    listGptModel
) => {
    setIsShowPopUpCancel(false);
    setIsClosePanelVersion({
        isClose: false,
        componentType: ProductManagementConstant.EDITION_LIST
    });
    let dataSubmit = {
        API,
        isSubmit,
        versionName,
        setVersionName,
        functionSettingValue,
        setFunctionSettingValue,
        basicSettingValue,
        setBasicSettingValue,
        advancedSettingValue,
        setAdvancedSettingValue,
        setUsedFormButtonExpand,
        dataProduct,
        userId,
        setIsLoading,
        enqueueSnackbar,
        onBackEditionPanel,
        setOpenDropDownVersion,
        isEditVersion,
        setIsOpenModalReloadPage,
        setIsBackToProduct,
        setIsBackToEdition,
        isDuplicateVersion,
        lincenseKey,
        setLincenseKey,
        affiliationOrganization,
        basicPromptAI: basicAIPrompt,
        defaultBasicAIPrompt,
        systemPrompt,
        chatGPTModel,
        knn,
        minScore,
        setDefaultSystemPrompt,
        setChatGPTModelDefault,
        setKnnDefault,
        setMinScoreDefault,
        interatorSystemPrompt,
        setDefaultInteratorSystemPrompt,
        setModelSettingList,
        setModelSettingAddList,
        modelSettingList,
        modelSettingAddList,
        isShowPopUpCancel, 
        setIsShowPopUpCancel,
        setIsReloadPage,
        listGptModel
    }
    await handleSubmitFormVersion(dataSubmit);
};

export const onClickCancelVersion = (setIsShowPopUpCancel, isEdit, onBackEditionPanel, dataProduct) => {
    if(isEdit) {
        setIsShowPopUpCancel(true);
        return;
    }
    let editionData = {
        id: dataProduct?.productId,
        productId: dataProduct?.productId,
        name: dataProduct?.nameProduct
    };
    
    return onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST);
}

export const getVersionDataById = async (
    API,
    versionId,
    setIsLoading,
    setVersionName,
    setFunctionSettingValue,
    setBasicSettingValue,
    setAdvancedSettingValue,
    setDefaultFunctionSettingValue,
    setDefaultBasicSettingValue,
    setDefaultAdvancedSettingValue,
    setDefaultVersionNameValue,
    isDuplicateVersion,
    setIsOpenModalReloadPage,
    setIsBackToProduct,
    setIsBackToEdition,
    editionId,
    productId,
    setBasicAIPrompt,
    setDefaultBasicAIPrompt,
    setSystemPrompt,
    setDefaultSystemPrompt,

    setChatGPTModel,
    setKnn,
    setMinScore,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    chatGPTModelDefault,
    knnDefault,
    minScoreDefault,
    setInteratorSystemPrompt,
    setDefaultInteratorSystemPrompt,
    setModelSettingList,
    setModelSettingAddList,
    setModelSettingListRoot,
    setKBoardSystemPromptLink,
    setDefaultKBoardSystemPromptLink,
    setKBoardPromptDetail,
    setErrorKBoardSystemPrompt
) => {
    if (!versionId) {
        return;
    }
    setIsLoading(true);
    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_VERSION_BY_ID,
        versionId: versionId,
        editionId: editionId,
        productId: productId
    };

    let res = await getProductById(API, requestBody);
    if (!res || !res.status) {
        setIsLoading(false);
        if(res?.errorMessage === "isNotProductExist") {
            setIsBackToProduct(true)
            setIsOpenModalReloadPage(true);
        }
        if(res?.errorMessage === "isNotEditionExist" || res?.errorMessage === "isNotVersionExist") {
            setIsBackToEdition(true)
            setIsOpenModalReloadPage(true);
        }
        return;
    }
    let versionData = Utils.convertJSONDataToObject(res.versionDetail);
    setBasicAIPrompt(!Utils.isEmptyObject(versionData.basicPromptAI) ? versionData.basicPromptAI: {});
    setDefaultBasicAIPrompt(!Utils.isEmptyObject(versionData.basicPromptAI) ? versionData.basicPromptAI: {});
    let versionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, versionData.name);
    let errorVersionName = ''
    if (isDuplicateVersion) {
        versionName+=' - Copy';
        errorVersionName = versionName.length > 200 ? I18n.get('COMMSG022').replace('{{maxLength}}', '200') : '';
    }
    setVersionName({
        value: versionName,
        error: errorVersionName
    });

    let moduleSetting = versionData.moduleSetting;
    if (setKBoardSystemPromptLink) {
        setKBoardSystemPromptLink(moduleSetting?.kBoardSystemPrompt || '');
    }
    if (setDefaultKBoardSystemPromptLink) {
        setDefaultKBoardSystemPromptLink(moduleSetting?.kBoardSystemPrompt || '');
    }
    
    if (setKBoardPromptDetail) {
        const savedLink = moduleSetting?.kBoardSystemPrompt || '';
        if (!Utils.isEmptyString(savedLink)) {
            const { isValid, ticketDetail } = await resolveKBoardPromptTicket(savedLink);
            if (isValid) {
                setKBoardPromptDetail(ticketDetail);
                if (setErrorKBoardSystemPrompt) setErrorKBoardSystemPrompt('');
            } else if (!Utils.isEmptyObject(ticketDetail)) {
                // Prompt bị soft delete hoặc save draft → giữ chip + hiển thị warning
                setKBoardPromptDetail(ticketDetail);
                if (setErrorKBoardSystemPrompt) setErrorKBoardSystemPrompt(Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK);
            } else {
                if (setKBoardSystemPromptLink) setKBoardSystemPromptLink('');
                setKBoardPromptDetail({});
                if (setErrorKBoardSystemPrompt) setErrorKBoardSystemPrompt('');
            }
        } else {
            setKBoardPromptDetail({});
            if (setErrorKBoardSystemPrompt) setErrorKBoardSystemPrompt('');
        }
    }
    let defaultFunctionSettingValue = {
        internalQACounterSettings: {
            value: moduleSetting.internalQACounterSettings || false 
        },
        externalServiceDeskSettings: {
            group: {
                deskService: {
                    value: moduleSetting.deskService || false
                },
                publicWebForm: {
                    value: moduleSetting.publicWebForm || false
                }
            }
        },
        emailResponseFunction: {
            value: moduleSetting.emailResponseFunction || false
        },
        knowledgeFunction: {
            group: {
                knowledgeService: {
                    value: moduleSetting.knowledgeService || false
                },
                publicService: {
                    value: moduleSetting.publicService || false
                },
                knowledgeBot: {
                    value: moduleSetting.knowledgeBot || false
                },
                convertPDF: {
                    value: moduleSetting.convertPDF || false
                },
                synonymSearch: {
                    value: moduleSetting.synonymSearch || false
                },
                batchCommandService: {
                    value: moduleSetting?.batchCommandService || false
                }
            }
        },
        chatAI: {
            value: moduleSetting.chatAI || false
        },
        lincenseKeyPermission: {
            value: moduleSetting.lincenseKeyPermission || false
        },
        aiAuto: {
            value: moduleSetting?.aiAuto || false
        },
        sdAuto: {
            value: moduleSetting?.sdAuto || false
        },
        telephoneAgent: {
            value: moduleSetting?.chatAI && moduleSetting?.aiAuto && moduleSetting?.telephoneAgent ? true : false
        },
        fileTranslation: {
            value: moduleSetting?.chatAI && moduleSetting?.aiAuto && moduleSetting?.fileTranslation ? true : false
        },
        kBoard: {
            value: moduleSetting?.chatAI && moduleSetting?.kBoard ? true : false
        },
        externalWebAPI: {
            value: moduleSetting?.externalWebAPI || false
        },
        mcpServer: {
            value: moduleSetting?.mcpServer || false
        },
        localMcpEnabled: {
            value: moduleSetting?.localMcpEnabled || {}
        },
        multiLanguage: {
            value: moduleSetting?.multiLanguage || false
        },
        taskManagement: {
            value: moduleSetting.taskManagement || false
        },
        advancedOptionSettings: {
            value: moduleSetting.advancedOptionSettings || false
        },
        logAnalysis: {
            value: moduleSetting.logAnalysis || false
        },
        ipRestriction: {
            value: moduleSetting?.ipRestriction || false
        },
        multiAuth: {
            value: moduleSetting?.multiAuth || false
        }
    };
    let defaultBasicSettingValue = {};
    let defaultAdvancedSettingValue = {};

    Object.keys(BASIC_SETTING).forEach(field => {
        if (field === Constant.SETTING_VERSION_LABEL.NUMBER_OF_EX_WEB_API) {
            defaultBasicSettingValue[field] = {
                number: {
                    type: BASIC_SETTING[field].number.type,
                    value: moduleSetting[field]?.number || '',
                    unit: BASIC_SETTING[field].number.unit,
                    error: '',
                    rules: BASIC_SETTING[field].number.rules
                },
                isUseUnlimited: {
                    value: moduleSetting[field]?.isUseUnlimited ?? true
                }
            };
            return;
        }
        defaultBasicSettingValue[field] = {
            type: BASIC_SETTING[field].type,
            value: moduleSetting[field],
            unit: BASIC_SETTING[field].unit,
            error: '',
            rules: BASIC_SETTING[field].rules
        };
    });

    Object.keys(ADVANCED_SETTING).forEach(field => {
        defaultAdvancedSettingValue[field] = {};

        Object.entries(ADVANCED_SETTING[field]).forEach(subField => {
            const [key, attrs] = subField
            const fieldKeyMap = {
                quantity: ProductManagementConstant.ADVANCED_SETTING_KEY_MAP.VALUE,
                price: ProductManagementConstant.ADVANCED_SETTING_KEY_MAP.PRICE
            };

            defaultAdvancedSettingValue[field][key] = {
                        type: ADVANCED_SETTING[field][key].type,
                        value: moduleSetting[field]?.[fieldKeyMap[key]] ?? '',
                        error: '',
                        rules: ADVANCED_SETTING[field][key].rules
            };
        });
    });

    setFunctionSettingValue(defaultFunctionSettingValue);
    setBasicSettingValue(defaultBasicSettingValue);
    setAdvancedSettingValue(defaultAdvancedSettingValue);

    setDefaultFunctionSettingValue(defaultFunctionSettingValue);
    setDefaultBasicSettingValue(defaultBasicSettingValue);
    setDefaultAdvancedSettingValue(defaultAdvancedSettingValue);
    setDefaultVersionNameValue({
        value: versionName,
        error: errorVersionName
    })

    setChatGPTModel(moduleSetting.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
    setKnn({
        value: moduleSetting?.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
        error: ''
    })
    setMinScore({
        value: moduleSetting?.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
        error: ''
    })
    
    setChatGPTModelDefault(moduleSetting.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
    setKnnDefault({
        value: moduleSetting?.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
        error: ''
    })
    setMinScoreDefault({
        value: moduleSetting?.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
        error: ''
    })

    let modelSettingList = moduleSetting?.modelSettingList;
    modelSettingList = createModelSettingListForOldCorp(modelSettingList);
    setModelSettingList(modelSettingList);
    setModelSettingAddList([]);
    setModelSettingListRoot(modelSettingList);

    setIsLoading(false);
    return;
};

const createModelSettingListForOldCorp = modelSettingList => {
    if (!Utils.isEmptyArray(modelSettingList)) {
        let newModelSettingList = modelSettingList.map(item => ({
            ...item,
            id: uuidv4()
        }));
        newModelSettingList = newModelSettingList.sort((a, b) => {
            return new Date(b?.createdAt) - new Date(a?.createdAt);
        });
        return newModelSettingList;
    }

    return [];
};

export const validateTextField = (rules, inputValue, key) => {

    if (!Array.isArray(rules)) return '';
    const hasIsRequire = rules.some(rule => rule.name === 'isRequire');
    if (Utils.isEmptyString(inputValue) && hasIsRequire && ['knn', 'minScore'].includes(key)) 
        return I18n.get('MSG-CM-REQUIRED-INPUT');
    let errorMessage = '';

    const validate = rules.some((rule) => {
        const regexNumber = /^\d+$/;
        const regexDecimal = /^[0-9]+(\.[0-9]+)?$/;

        switch (rule.name) {
            case 'isNumber':
                if (!regexNumber.test(inputValue)) {
                    if(key === 'numberOfTickets') {
                        errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', 1);
                        return true;
                    } else if (key === 'knn') {
                        errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                        return true;
                    } else if (key === Constant.SETTING_VERSION_LABEL.NUMBER_OF_EX_WEB_API) {
                        errorMessage = I18n.get('MSG-CM-OVER-MAX-CAPACITY').replace('{{max_capacity}}', 1);
                        return true;
                    } else {
                        errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', 0);
                        return true;
                    }
                }
                if(key === 'knn' && inputValue.startsWith('0')) {
                    errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                    return true;
                }
                break;

            case 'isDecimal':
                if (key === 'minScore') {
                    if (!regexDecimal.test(inputValue)) {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                        return true;
                    }
                    if(inputValue.startsWith('0') && !inputValue.includes('.') && inputValue !== '0') {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                        return true;
                    }
                    return true;
                }
                if (!regexDecimal.test(inputValue)) {
                    errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-DOT-FORMAT');
                    return true;
                }
                if(inputValue.startsWith('0') && !inputValue.includes('.')) {
                    errorMessage = I18n.get('MSG-CM-STORAGE-ERROR');
                    return true;
                }
                if(Utils.removeExcessZeros(inputValue) === "0") {
                    errorMessage = I18n.get('MSG-CM-STORAGE-ERROR');
                    return true;
                }
                const [integerPart, decimalPart] = inputValue.split('.');
                if (
                    (!Utils.isEmptyString(integerPart) && integerPart.length > 4) ||
                    (!Utils.isEmptyString(decimalPart) && decimalPart.length > 3)
                ) {
                    errorMessage = I18n.get('MSG-CM-STORAGE-ERROR');
                    return true;
                }
                break;

            case 'maxLength':
                if (inputValue.length > rule.value) {
                    if (Utils.isNumber(inputValue)) {
                        errorMessage = I18n.get('COMMSG022').replace('{{maxLength}}', rule.value);
                        return true;
                    }
                    errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', 1);
                    return true;
                }
                break;
            case 'minValue':
                if (inputValue < rule.value) {
                    if (key === 'knn') {
                        errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                    } else if (key === 'minScore') {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                    } else {
                        errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', rule.value);
                    }
                    return true;
                }
                break;
            case 'maxValue':
                if (inputValue > rule.value) {
                    if (key === 'knn') {
                        errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                    }
                    if (key === 'minScore') {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                    }
                    return true;
                }
                break;
            default:
                errorMessage = ``;
                return false;
        }

        //default value
        return false;
    });
    
    if(validate) {
        return errorMessage 
    }else {
        return '' ;
    }
};


export const getProductLicenseKeySetting = async (
    API,
    productId,
    affiliationOrganization,
    setLincenseKey,
    setIsRootSetting,
    setIsLoading,
    setLicenseKeyDefault
) => {
    if (!productId) {
        return;
    }
    setIsLoading(true);

    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_PRODUCT_BY_ID,
        affiliationOrganization: affiliationOrganization,
        productId: productId
    };
    let product = await getDetailByProductId(API, requestBody);

    if (product?.moduleSetting) {
        let moduleSetting = Utils.convertJSONDataToObject(product.moduleSetting);
        setLincenseKey(prev => ({
            ...prev,
            value: moduleSetting.lincenseKeySetting.key
        }));
        setLicenseKeyDefault(moduleSetting.lincenseKeySetting.key);

        if (affiliationOrganization !== moduleSetting.lincenseKeySetting.affiliationOrganization) {
            setIsRootSetting(false);
        }
    }

    setIsLoading(false);
    return;
};

export const handleOnBlurSystemPromptModelSetting = async (params) => {
    const {
        e,
        API,
        setIsLoading,
        setIsEdited,
        setModelSettingAddList,
        currentIndex,
        fieldKey
    } = params;
    if (Utils.isEmptyString(e.target.value)) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            value: '',
                            linkPrompt: '',
                            error: '',
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        return;
    }
    const invalidLinkMessage = Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK;
    let linkSystemPrompt = e.target.value;
    if (!Utils.isValidLinkPromptInput(e.target.value)) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            linkPrompt: linkSystemPrompt,
                            error: invalidLinkMessage
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        return;
    }
    setIsLoading(true);
    const idTicket = await Utils.getTicketIdByShareLink(linkSystemPrompt);

    let paramsGetTitleTicketPrompt = {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TITLE_OF_TICKET_PROMPT,
        ticketId: idTicket
    };

    let ticketTitleData = await getPublicAPI(API, paramsGetTitleTicketPrompt);
    if (Utils.isEmptyObject(ticketTitleData)) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            linkPrompt: linkSystemPrompt,
                            error: invalidLinkMessage
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        setIsLoading(false);
        return;
    }
    if (!ticketTitleData.success) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            linkPrompt: linkSystemPrompt,
                            error: invalidLinkMessage
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        setIsLoading(false);
        return;
    }
    let payload = Utils.convertJSONDataToObject(ticketTitleData.payload);
    setModelSettingAddList(prevList => {
        const updatedList = prevList.map(item => {
            if (item.id === currentIndex) {
                return {
                    ...item,
                    [fieldKey]: {
                        ...item[fieldKey],
                        value: payload.titleTicket,
                        error: '',
                        linkPrompt: linkSystemPrompt
                    }
                };
            }
            return item;
        });
        return updatedList;
    });
    setIsLoading(false);

    setIsEdited(true);
};

export const handleOnBlurEditSystemPromptModelSetting = async (params) => {
    const {
        e,
        API,
        setIsLoading,
        systemPromptData,
        setIsEdited,
        setIsChangeSystemPromptData,
        setModelSettingAddList,
        currentIndex,
        fieldKey
    } = params;
    if (Utils.isEmptyString(e.target.value)) {
        if (!Utils.isEmptyString(systemPromptData)) {
            setIsChangeSystemPromptData(true);
        }
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            value: '',
                            linkPrompt: '',
                            error: '',
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        return;
    }
    const invalidLinkMessage = Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK;
    let linkSystemPrompt = e.target.value;
    if (!Utils.isValidLinkPromptInput(e.target.value)) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            linkPrompt: linkSystemPrompt,
                            error: invalidLinkMessage
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        return;
    }
    setIsLoading(true);
    const idTicket = await Utils.getTicketIdByShareLink(linkSystemPrompt);

    let paramsGetTitleTicketPrompt = {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TITLE_OF_TICKET_PROMPT,
        ticketId: idTicket
    };

    let ticketTitleData = await getPublicAPI(API, paramsGetTitleTicketPrompt);
    if (Utils.isEmptyObject(ticketTitleData)) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            linkPrompt: linkSystemPrompt,
                            error: invalidLinkMessage
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        setIsLoading(false);
        return;
    }
    if (!ticketTitleData.success) {
        setModelSettingAddList(prevList => {
            const updatedList = prevList.map(item => {
                if (item.id === currentIndex) {
                    return {
                        ...item,
                        [fieldKey]: {
                            ...item[fieldKey],
                            linkPrompt: linkSystemPrompt,
                            error: invalidLinkMessage
                        }
                    };
                }
                return item;
            });
            return updatedList;
        });
        setIsLoading(false);
        return;
    }
    let payload = Utils.convertJSONDataToObject(ticketTitleData.payload);
    setModelSettingAddList(prevList => {
        const updatedList = prevList.map(item => {
            if (item.id === currentIndex) {
                return {
                    ...item,
                    [fieldKey]: {
                        ...item[fieldKey],
                        value: payload.titleTicket,
                        error: '',
                        linkPrompt: linkSystemPrompt
                    }
                };
            }
            return item;
        });
        return updatedList;
    });
    setIsLoading(false);

    setIsEdited(true);
    setIsChangeSystemPromptData(true);
};

export const handleAddNew = (modelSettingAddList, setModelSettingAddList) => {
    let newModelSettingData = {
        id: uuidv4(),
        model: '',
        systemPrompt: {
            value: '',
            error: '',
            linkPrompt: '',
            isPromptValid: true
        },
        interatorSystemPrompt: {
            value: '',
            error: '',
            linkPrompt: '',
            isPromptValid: true
        },
        isEdit: '',
        isAddNew: true,
    };

    setModelSettingAddList(prev => ([
        newModelSettingData,
        ...prev
    ]));
};

export const editModelSetting = async (index, model, args) => {
    let modelSettingListClone = [...args.modelSettingList];
    if (modelSettingListClone[index].editing !== 1) {
        modelSettingListClone[index].editing = 1;
    }

    args.setIsEdited(true);
    args.setModelSettingList([...modelSettingListClone]);
};

const updateDuplicateError = (listA, listB) => {
        const combined = [...listA, ...listB];
        // Count the number of times a model occurs
        const modelCount = combined.reduce((acc, item) => {
            if (item.model) {
                acc[item.model] = (acc[item.model] || 0) + 1;
            }
            return acc;
        }, {});

        // model is duplicated
        const duplicateModels = Object.keys(modelCount).filter(model => modelCount[model] > 1);

        let hasAnyDuplicate = duplicateModels.length > 0;
        let hasAnyBlankModel = false;

        const applyError = item => {
            const isModelBlank = !item.model || item.model.trim() === '';
            const isDup = duplicateModels.includes(item.model);

            if (isModelBlank) hasAnyBlankModel = true;

            let error;
            if (isModelBlank) {
                error = 'MSG_AI_MODEL_REQUIRED';
            } else if (isDup) {
                error = 'MSG_AI_MODEL_DUPLICATE';
            }

            return {
                ...item,
                hasDuplicate: isDup,
                isModelBlank,
                error
            };
        };

        return {
            newListModelSetting: listA.map(applyError),
            newListAddModelSetting: listB.map(applyError),
            hasAnyDuplicate,
            hasAnyBlankModel
        };
    };

export const handleChangeModel = (e, dataChange) => {
    let {
        modelSetting, 
        setModelSetting, 
        currentAddList, 
        currentIndex, 
        setModelSettingAddList,
        modelSettingList,
        setModelSettingList,
        chatGPTModelList,
        setIsEdited
    } = dataChange;
    const newValue = e.target.value;

    const updatedModelSetting = {
        ...modelSetting,
        model: newValue
    };
    setModelSetting(updatedModelSetting);
    let modelDuplicate = currentAddList.find(item => item?.id === currentIndex);
    
    setModelSettingAddList(prevList => {
        // Count duplicate elements
        const duplicates = prevList.filter(
            item => item.id !== currentIndex && item.model === modelDuplicate?.model
        );
        const duplicateRootModel = modelSettingList.filter(
            item => item.id !== currentIndex && item.model === modelDuplicate?.model
        );
        const onlyOneDuplicate = duplicates.length === 1;
        const duplicateId = onlyOneDuplicate ? duplicates[0].id : null;

        return prevList.map(item => {
            if (item.id === currentIndex) {
                return {
                    ...item,
                    model: newValue,
                    isModelBlank: false,
                    hasDuplicate: false,
                    error: ''
                };
            }
            if (onlyOneDuplicate && item.id === duplicateId && Utils.isEmptyArray(duplicateRootModel)) {
                return { ...item, hasDuplicate: false, error: '' };
            }
            return item;
        });
    });

    if (modelDuplicate?.hasDuplicate) {
        let modelName = modelDuplicate?.model;
        setModelSettingList(prevList =>
            prevList.map(item =>
                item.model === modelName
                    ? {
                            ...item,
                            hasDuplicate: false,
                            error: ''
                        }
                    : item
            )
        );
    }

    const isUnsupported = checkModelUnsupport(newValue, chatGPTModelList);
    setIsEdited(!isUnsupported);
};

export const onDeleteAddModelSetting = (dataDelete) => {
    let {
        model, 
        modelSettingAddList,
        modelSettingList,
        setModelSettingAddList,
        setModelSettingList,
        setIsEdit
    } = dataDelete;
    let currentAddList = [...modelSettingAddList];
    currentAddList = currentAddList.filter((e, i) => e?.id !== model?.id);
    let modelName = model?.model;
    if (!Utils.isEmptyString(modelName)) {
        const duplicates = currentAddList.filter(
            item => item.id !== model.id && item.model === modelName
        );
        const duplicateRootModel = modelSettingList.filter(
            item => item.id !== model.id && item.model === modelName
        );
        const onlyOneDuplicate = duplicates?.length === 1;
        const duplicateId = onlyOneDuplicate ? duplicates[0].id : null;

        currentAddList = currentAddList.map(item => {
            if (onlyOneDuplicate && item.id === duplicateId && Utils.isEmptyArray(duplicateRootModel)) {
                return { ...item, hasDuplicate: false, error: '' };
            }
            return item;
        });
    }

    setModelSettingAddList(currentAddList);
    if (model?.hasDuplicate) {
        setModelSettingList(prevList =>
            prevList.map(item =>
                item.model === modelName
                    ? {
                            ...item,
                            hasDuplicate: false,
                            error: ''
                        }
                    : item
            )
        );
    }

    setIsEdit(true);
};

export const onDeleteModelSetting = (dataDelete) => {
    let {
        model, 
        modelSettingAddList,
        modelSettingList,
        setModelSettingAddList,
        setModelSettingList,
        setIsEdit
    } = dataDelete;
    let currentSettingList = [...modelSettingList];
    currentSettingList = currentSettingList.filter((e, i) => e?.id !== model?.id);
    let modelName = model?.model;
    if (!Utils.isEmptyString(modelName)) {
        const duplicates = currentSettingList.filter(
            item => item.id !== model.id && item.model === modelName
        );
        const duplicateAddModel = modelSettingAddList.filter(
            item => item.id !== model.id && item.model === modelName
        );
        const onlyOneDuplicate = duplicates?.length === 1;
        const duplicateId = onlyOneDuplicate ? duplicates[0].id : null;

        currentSettingList = currentSettingList.map(item => {
            if (onlyOneDuplicate && item.id === duplicateId && Utils.isEmptyArray(duplicateAddModel)) {
                return { ...item, hasDuplicate: false, error: '' };
            }
            return item;
        });
    }
    setModelSettingList(currentSettingList);
    
    if (model?.hasDuplicate) {
        let currentModelSettingAddList = [...modelSettingAddList]
        if (!Utils.isEmptyString(modelName)) {
            const duplicates = currentModelSettingAddList.filter(
                item => item.id !== model.id && item.model === modelName
            );
            const onlyOneDuplicate = duplicates?.length === 1;
            const duplicateId = onlyOneDuplicate ? duplicates[0].id : null;

            currentModelSettingAddList = currentModelSettingAddList.map(item => {
                if (onlyOneDuplicate && item.id === duplicateId) {
                    return { ...item, hasDuplicate: false, error: '' };
                }
                return item;
            });
        }
        setModelSettingAddList(currentModelSettingAddList);
    }
    setIsEdit(true);
}

export const handleModelChange = (dataChange) => {
    let {
        itemId,
        newModel,
        modelSettingAddList,
        setModelSettingAddList,
        modelSettingList,
        setModelSettingList,
        chatGPTModelList,
        setIsEdit
    } = dataChange;

    const isUnsupport = checkModelUnsupport(newModel, chatGPTModelList);
    let modelDuplicate = modelSettingList.find(item => item?.id === itemId);
    let modelName = modelDuplicate?.model;

    setModelSettingList(prevList => {
        // Count duplicate elements
        const duplicates = prevList.filter(
            item => item.id !== itemId && item.model === modelName
        );
        const duplicateAddModel = modelSettingAddList.filter(
            item => item.id !== itemId && item.model === modelName
        );
        const onlyOneDuplicate = duplicates.length === 1;
        const duplicateId = onlyOneDuplicate ? duplicates[0].id : null;

        return prevList.map(item => {
            if (item.id === itemId) {
                return {
                    ...item,
                    model: newModel,
                    hasDuplicate: false,
                    error: ''
                };
            }
            if (onlyOneDuplicate && item.id === duplicateId && Utils.isEmptyArray(duplicateAddModel)) {
                return { ...item, hasDuplicate: false, error: '' };
            }
            return item;
        });
    });

    if (modelDuplicate?.hasDuplicate) {
        let currentModelSettingAddList = [...modelSettingAddList]
        if (!Utils.isEmptyString(modelName)) {
            const duplicates = currentModelSettingAddList.filter(
                item => item.id !== modelDuplicate.id && item.model === modelName
            );
            const duplicateRootModel = modelSettingList.filter(
                item => item.id !== modelDuplicate.id && item.model === modelName
            );
            const onlyOneDuplicate = duplicates?.length === 1;
            const duplicateId = onlyOneDuplicate ? duplicates[0].id : null;

            currentModelSettingAddList = currentModelSettingAddList.map(item => {
                if (onlyOneDuplicate && item.id === duplicateId && Utils.isEmptyArray(duplicateRootModel)) {
                    return { ...item, hasDuplicate: false, error: '' };
                }
                return item;
            });
        }
        setModelSettingAddList(currentModelSettingAddList);
    }
    
    setIsEdit(!isUnsupport);
};
